import React from 'react';
import { Typography as MuiTypography, styled } from '@mui/material';

// Современный стиль типографики
const StyledTypography = styled(MuiTypography)(({ theme, variant }) => ({
  // Стили для заголовков
  ...(variant?.startsWith('h') && {
    fontWeight: 700,
    letterSpacing: '-0.03em',
    marginBottom: '0.6em',
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  }),

  // Специфические стили для разных уровней заголовков
  ...(variant === 'h1' && {
    fontSize: '2.75rem',
  }),
  ...(variant === 'h2' && {
    fontSize: '2.25rem',
  }),
  ...(variant === 'h3' && {
    fontSize: '1.875rem',
  }),

  // Стили для основного текста
  ...(variant === 'body1' && {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: theme.palette.text.primary,
    fontWeight: 400,
  }),
  ...(variant === 'body2' && {
    fontSize: '0.925rem',
    lineHeight: 1.7,
    fontWeight: 400,
  }),

  // Стили для подзаголовков
  ...(variant === 'subtitle1' && {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: '0.5em',
  }),
  ...(variant === 'subtitle2' && {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: '0.5em',
  }),

  // Стили для подписей
  ...(variant === 'caption' && {
    fontSize: '0.8rem',
    letterSpacing: '0.03em',
    color: theme.palette.text.secondary,
    fontWeight: 400,
  }),
}));

const Typography = (props) => {
  return <StyledTypography {...props} />;
};

export default Typography;
